import { Cookies } from "react-cookie";
import { CookieSetOptions } from "universal-cookie";

const cookies = new Cookies();

export const ACCESS_TOKEN = "atlas-access";
export const REFRESH_TOKEN = "atlas-refresh";
export const ADMIN = "atlas-isAdmin";

export const setCookie = (
  name: string,
  value: any,
  options?: CookieSetOptions | undefined,
) => {
  return cookies.set(name, value, { ...options });
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const removeCookie = (name: string) => {
  return cookies.remove(name);
};

export const checkToken = (): boolean => {
  return getCookie(ACCESS_TOKEN) ? true : false;
};

export const checkAdmin = (): boolean => {
  return JSON.parse(localStorage.getItem(ADMIN) as string);
};
